module.exports = __webpack_public_path__ + "sudan.svg?8aa901429b1b9ac508b1373e0f591edb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/sudan.svg
// module id = 307
// module chunks = 10